import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { EnvelopeSimple, X } from '@phosphor-icons/react';
import { getToken, updateUserData } from '@/utils/auth';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const VerifyEmailBanner = ({ user, onUpdate }) => {
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (user.email_verified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      const token = getToken();
      const response = await axios.post(
        `${API}/auth/resend-verification`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Verification email sent! Check your inbox.');
      if (response.data.dev_verify_link) {
        toast.info('Dev mode: check console for link');
        // eslint-disable-next-line no-console
        console.log('Verify link:', response.data.dev_verify_link);
      }
    } catch (error) {
      toast.error('Failed to send verification email');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-2 flex items-center gap-3" data-testid="verify-banner">
      <EnvelopeSimple size={18} weight="fill" className="text-yellow-700 flex-shrink-0" />
      <p className="text-sm text-yellow-800 flex-1">
        Please verify your email address ({user.email}) to unlock all features.
      </p>
      <Button
        size="sm"
        variant="outline"
        onClick={handleResend}
        disabled={sending}
        className="border-yellow-300 text-yellow-800 hover:bg-yellow-100"
        data-testid="resend-verification-button"
      >
        {sending ? 'Sending...' : 'Resend Email'}
      </Button>
      <button
        onClick={() => setDismissed(true)}
        className="text-yellow-700 hover:text-yellow-900"
        data-testid="dismiss-verify-banner"
      >
        <X size={16} weight="bold" />
      </button>
    </div>
  );
};
